import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = ["disabled", "placeholder"]
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "flex flex-row flex-wrap flex-shrink gap-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "text-left mt-2" }
const _hoisted_24 = { class: "flex flex-row justify-around" }
const _hoisted_25 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import FileUploader from "../tools/FileUploader.vue";
import { translate } from "@/utils/tools";

interface IImageProp {
  url: string;
  link: string;
}
interface IProps {
  id: string;
  keyName: string;
  description: string;
  linkTo: string;
  publish: boolean;
  images?: IImageProp[];
  hasScheduler: boolean;
  schedulerDateStart: Date | string;
  schedulerDateEnd: Date | string;
  schedulerTimeStart: Date | string;
  schedulerTimeEnd: Date | string;
  schedulerDay: string[];
  isOneTime: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerEdit',
  props: { show: Boolean, form: Object },
  emits: ["submit", "update:show", "form", "edited", "closed"],
  setup(__props, { emit }) {

const props = __props

const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");


const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const formSync = ref<IProps>();
const preview = ref(props.form?.imageUrl);
const previewName = ref("");
const file = ref();
const isOnetime = ref(false);
const isPublic = ref(false);
const avaliableDays = ref<string[]>([]);
const days = ref([
  { name: translate("messages.banner.sunday"), val: "SUN" },
  { name: translate("messages.banner.monday"), val: "MON" },
  { name: translate("messages.banner.tuesday"), val: "TUE" },
  { name: translate("messages.banner.wednesday"), val: "WED" },
  { name: translate("messages.banner.thuesday"), val: "THU" },
  { name: translate("messages.banner.friday"), val: "FRI" },
  { name: translate("messages.banner.saturday"), val: "SAT" },
]);

const onSelectSchudule = (val: string) => {
  if (avaliableDays.value.includes(val)) {
    avaliableDays.value = avaliableDays.value.filter((a) => a !== val);
  } else {
    avaliableDays.value.push(val);
  }
};
const onFileSelected = async () => {
  const formData = new FormData();
  const files = file.value.files;
  formData.append("file", files[0]);
  formData.append("uploadType", "banner");

  try {
    const image = await uploadPic(formData);

    if (image && image.data.imageUrl) {
      preview.value = image.data.imageUrl;
      previewName.value = image.data.originalName;
    }
  } catch (error) {
    alert(error);
  }
};

const uploadPic = async (formData: FormData) => {
  return await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/upload/api/internal/image`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};
const clearForm = () => {
  formSync.value = {
    id: "",
    description: "",
    linkTo: "",
    hasScheduler: false,
    isOneTime: false,
    keyName: "",
    publish: false,
    schedulerDateEnd: "",
    schedulerDateStart: "",
    schedulerDay: [],
    schedulerTimeEnd: "",
    schedulerTimeStart: "",
    images: [],
  };
};
const onClose = () => {
  clearForm();
  avaliableDays.value = [];
  showSync.value = false;
  emit("closed");
};

const onUpdate = async () => {
  const payload = {
    id: formSync.value?.id,
    keyName: formSync.value?.keyName,
    description: formSync.value?.description,
    linkTo: formSync.value?.linkTo,
    publish: isPublic.value,
    images: formSync.value?.images,
    hasScheduler: formSync.value?.hasScheduler,
    schedulerDateStart: formSync.value?.schedulerDateStart,
    schedulerDateEnd: formSync.value?.schedulerDateEnd,
    schedulerTimeStart: formSync.value?.schedulerTimeStart,
    schedulerTimeEnd: formSync.value?.schedulerTimeEnd,
    schedulerDay: avaliableDays.value,
    isOneTime: isOnetime.value,
  };

  await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/banner/update`,
    payload
  );
  emit("edited");
  avaliableDays.value = [];
  showSync.value = false;
};

watch(showSync, (val) => {
  if (val) {
    formSync.value = props.form as IProps;
    preview.value = (props.form as any).imageUrl;

    if (props.form?.isOneTime) isOnetime.value = props.form.isOneTime;
    if (props.form?.publish) isPublic.value = props.form.publish;

    if ((props.form as any).schedulerDay === null) {
      avaliableDays.value = [];
    } else {
      avaliableDays.value = (props.form as any).schedulerDay;
    }
  }
});

// watch((props.form as any).imageUrl,(val) => {
//   preview.value = val
// },{deep:true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: onClose,
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.editBanners")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.banner.keyname")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSync.value.keyName) = $event)),
                              placeholder: _ctx.$t('messages.banner.keyname')
                            }, null, 8, _hoisted_7), [
                              [_vModelText, formSync.value.keyName]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.banner.description")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSync.value.description) = $event)),
                              placeholder: _ctx.$t('messages.banner.description')
                            }, null, 8, _hoisted_9), [
                              [_vModelText, formSync.value.description]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("messages.banner.linkTo")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSync.value.linkTo) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.banner.linkTo')
                            }, null, 8, _hoisted_11), [
                              [_vModelText, formSync.value.linkTo]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("messages.banner.schedulerStartDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSync.value.schedulerDateStart) = $event)),
                              placeholder: _ctx.$t('messages.banner.schedulerStartDate')
                            }, null, 8, _hoisted_13), [
                              [_vModelText, formSync.value.schedulerDateStart]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("messages.banner.schedulerStartTime")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSync.value.schedulerTimeStart) = $event)),
                              disabled: formSync.value.schedulerDateStart ? false : true,
                              placeholder: _ctx.$t('messages.banner.schedulerStartTime')
                            }, null, 8, _hoisted_15), [
                              [_vModelText, formSync.value.schedulerTimeStart]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("messages.banner.schedulerEndDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSync.value.schedulerDateEnd) = $event)),
                              placeholder: _ctx.$t('messages.banner.schedulerEndDate')
                            }, null, 8, _hoisted_17), [
                              [_vModelText, formSync.value.schedulerDateEnd]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("messages.banner.schedulerTimeEnd")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              disabled: formSync.value.schedulerDateEnd ? false : true,
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSync.value.schedulerTimeEnd) = $event))
                            }, null, 8, _hoisted_19), [
                              [_vModelText, formSync.value.schedulerTimeEnd]
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("messages.banner.schedulerRepeat")), 1),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, index) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: index,
                                class: _normalizeClass(["uppercase rounded px-2", 
                          avaliableDays.value.includes(day.val)
                            ? 'bg-blue-500 text-white'
                            : 'bg-indigo-100'
                        ]),
                                onClick: ($event: any) => (onSelectSchudule(day.val))
                              }, _toDisplayString(day.name), 11, _hoisted_22))
                            }), 128))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("messages.banner.image")), 1),
                            _createElementVNode("div", null, [
                              _createVNode(FileUploader, {
                                images: formSync.value.images,
                                "onUpdate:images": _cache[7] || (_cache[7] = ($event: any) => ((formSync.value.images) = $event)),
                                "upload-type": "banner",
                                endpoint: "/upload/api/internal/image"
                              }, null, 8, ["images"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.publish")) + " ", 1),
                              _createVNode(_unref(Switch), {
                                modelValue: isPublic.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isPublic).value = $event)),
                                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", isPublic.value ? 'bg-blue-400' : 'bg-red-500'])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                              isPublic.value ? 'translate-x-6' : 'translate-x-1'
                            , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"])
                            ]),
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.onetimeDisplay")) + " ", 1),
                              _createVNode(_unref(Switch), {
                                modelValue: isOnetime.value,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isOnetime).value = $event)),
                                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", isOnetime.value ? 'bg-blue-400' : 'bg-red-500'])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                              isOnetime.value ? 'translate-x-6' : 'translate-x-1'
                            , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"])
                            ]),
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t("messages.banner.useScheduler")) + " ", 1),
                              _createVNode(_unref(Switch), {
                                modelValue: formSync.value.hasScheduler,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSync.value.hasScheduler) = $event)),
                                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", 
                            formSync.value.hasScheduler ? 'bg-blue-400' : 'bg-red-500'
                          ])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                              formSync.value.hasScheduler
                                ? 'translate-x-6'
                                : 'translate-x-1'
                            , "inline-block h-4 w-4 transform rounded-full bg-white"])
                                  }, null, 2)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.banner.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (onUpdate()))
                      }, _toDisplayString(_ctx.$t("messages.banner.edit")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})